import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../lib/api';

function slugify(str=''){
  const m={å:'a',ä:'a',ö:'o',Å:'a',Ä:'a',Ö:'o'};
  return (str.replace(/[ÅÄÖåäö]/g,ch=>m[ch]||ch)
    .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
    .toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')) || 'item';
}

export default function CreateNewItemModal({
  open,
  onClose,
  sectionId,           // required: SiteContent _id
  onCreated,           // callback(newItem)
  title,               // optional; parent can pass a translated title
}) {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  if (!open) return null;

  async function handleSubmit(e){
    e.preventDefault();
    setErr('');
    if (!sectionId) { setErr(t('errors.missingSection')); return; }
    if (!name.trim()) { setErr(t('errors.nameRequired')); return; }
    try {
      setBusy(true);
      const payload = {
        contentId: sectionId,
        name,
        link: slugify(name),
        content: '',
        input: ''
      };
      const { data } = await api.post('/content-items', payload);
      onCreated?.(data.item);
      setName('');
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.response?.data?.msg || t('errors.failedToCreateItem'));
    } finally {
      setBusy(false);
    }
  }

  const headerTitle = title || t('editor.modal.defaultTitle');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <form
        onSubmit={handleSubmit}
        className="relative w-[min(520px,92vw)] bg-white p-6 rounded-lg shadow"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label={t('general.close')}
          className="absolute top-2 right-2 rounded px-2 pb-0.5 hover:bg-gray-800 hover:text-white"
        >
          ×
        </button>

        <h3 className="text-xl font-semibold mb-4">{headerTitle}</h3>

        <label className="block text-sm font-medium mb-1">
          {t('editor.modal.nameLabel')}
        </label>
        <input
          autoFocus
          className="w-full border rounded px-3 py-2 mb-2"
          value={name}
          onChange={e=>setName(e.target.value)}
          placeholder={t('editor.modal.namePlaceholder')}
        />

        {err && <div className="text-sm text-red-600 mb-2">{err}</div>}

        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-3 py-2 rounded border">
            {t('general.cancel')}
          </button>
          <button
            disabled={busy}
            className="px-3 py-2 rounded bg-blue-600 text-white disabled:opacity-60"
          >
            {busy ? t('editor.actions.creating') : t('editor.actions.create')}
          </button>
        </div>
      </form>
    </div>
  );
}
